import {Component, OnInit, AfterViewInit, Input, Output, ViewEncapsulation  } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';

@Component({
    selector: 'app-partner-license-company-dialog.component',
    templateUrl: 'partner-license-company-dialog.component.html',
    styleUrls: ['partner-license-company-dialog.component.scss'],
    encapsulation: ViewEncapsulation.None
  })

  export class PartnerLicenseDialogComponent implements OnInit {
    
    constructor(public matDialogRef: MatDialogRef<PartnerLicenseDialogComponent>) {

    }
  
    ngOnInit() {

    }

    close() {
      this.matDialogRef.close();
    }

  }